import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose } from 'recompose'
import * as routes from '../../constants/routes'
import { withRouter } from 'react-router-dom'
import { TOGGLE_VIEW, SELECTED_CANIDATE } from '../../constants/actionTypes'
import AdminCanidateSelect from './AdminCanidateSelect'
//import moment from 'moment'

import { withStyles } from '@material-ui/core/styles';
//import Paper from '@material-ui/core/Paper';
//import Button from '@material-ui/core/Button'
//import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';  
import AdminCanidateEventDetails from './AdminCanidateEventDetails';
import CanidateDetails from './CanidateDetails'
import {defaultGridSettings} from '../../js/settings/grid'

const styles = theme => ({
    
})


class AdminCanidateDetails extends Component {

componentDidMount () {
    const { history, openEvent } = this.props

   if(typeof(openEvent)==='undefined')
   history.push(routes.ADMINCANIDATELIST)
}

componentWillUnmount () {
    this.props.onResetCanidate(null)
}


    render() {
       const { openEvent } = this.props
        return (
            <div className={styles.root}>
                <Grid container {...defaultGridSettings.container}>
                    <Grid item {...defaultGridSettings.item} >
                        {openEvent===undefined
                            ? null
                            :<AdminCanidateEventDetails />
                        }
                    </Grid>
                    <Grid item {...defaultGridSettings.item} >
                        <AdminCanidateSelect />
                    </Grid>
                    <Grid item {...defaultGridSettings.item} >
                        <CanidateDetails />
                    </Grid>
                   
                </Grid>

            
            </div>
        )
    }
}

const mapStateToProps = (state) =>({
   // hiddenState: state.appState.hiddenState.AdminCanidateDetails,
    openEvent: state.adminCanidateState.currentOpenEvent.event

})

const mapDispatchToProps = (dispatch) => ({
    onToggleView: (payload)=>dispatch({type: TOGGLE_VIEW, payload}),
    onResetCanidate: (resetCanidate)=>dispatch({type: SELECTED_CANIDATE, payload: resetCanidate})
})



export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
    )   (AdminCanidateDetails)


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminCanidateDetails.js